import { useEffect } from "react";

import { useSnackbar } from "notistack";

import { PDFContentViewer } from "./PDFContentViewer";
import { PDFPreview } from "./PDFPreview";

import { trpc } from "@/common/helpers/trpc";
import { useBreakpointLogger } from "@/common/hooks/useBreakpointLogger";
import { useTranslate } from "@/common/hooks/useTranslate";
import { GetPreviewReceiptInHTMLInput } from "@/common/types/trpc";

export const ReceiptPDFPreview = (getPreviewReceiptInHTMLInput: GetPreviewReceiptInHTMLInput) => {
  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();
  const breakpoint = useBreakpointLogger();

  const {
    data: receiptHtml,
    isLoading: isReceiptHtmlLoading,
    isError,
  } = trpc.getPreviewReceiptInHTML.useQuery(getPreviewReceiptInHTMLInput);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(t("common", "unknownError", { code: 118 }), { vibe: "danger" });
    }
  }, [isError, enqueueSnackbar, t]);

  const stillLoading = isReceiptHtmlLoading || !receiptHtml;

  return (
    <PDFPreview dataTest="preview-tax-receipt-iframe" title="Tax Receipt Preview">
      <PDFContentViewer
        html={receiptHtml}
        breakpoint={breakpoint}
        isSkeleton={stillLoading}
        scaleSettings={{
          xl: 0.44,
          lg: 0.34,
          md: 0.25,
          xs: 0.25,
        }}
      />
    </PDFPreview>
  );
};
